// test1340
(1340 && 0);
